// extracted by mini-css-extract-plugin
export default {"content":"ellipsisContentColumn_content__416sv"};